import * as React from 'react';
import {Select as VWSelect} from '@volkswagen-onehub/components-core';
import {
  SelectProps,
  GroupedSelectProps,
} from '@volkswagen-onehub/whitelabel-e-mobility-commons';

export function Select({
  options,
  selectedValue,
  label,
  onChange,
  testId,
  disabled,
}: SelectProps): JSX.Element {
  const onChangeHandler = React.useCallback(
    (e: React.SyntheticEvent<HTMLSelectElement>) =>
      onChange(e.currentTarget.value),
    [onChange]
  );

  return (
    <VWSelect
      label={label}
      value={selectedValue}
      onChange={onChangeHandler}
      data-testid={testId}
      disabled={disabled}
    >
      {options.map((option) => (
        <option
          aria-selected={selectedValue === option.value}
          key={option.value}
          value={option.value}
        >
          {option.label}
        </option>
      ))}
    </VWSelect>
  );
}

export function GroupedSelect({
  optionGroups,
  selectedValue,
  label,
  onChange,
  testId,
}: GroupedSelectProps): JSX.Element {
  const onChangeHandler = React.useCallback(
    (e: React.SyntheticEvent<HTMLSelectElement>) =>
      onChange(e.currentTarget.value),
    [onChange]
  );

  return (
    <VWSelect
      label={label}
      value={selectedValue}
      onChange={onChangeHandler}
      data-testid={testId}
    >
      {optionGroups.map((group) => (
        <optgroup label={group.label} key={group.groupId}>
          {group.options.map((option, index) => (
            <option
              aria-selected={selectedValue === option.value}
              key={`${option.value},${index}`}
              value={option.value}
            >
              {option.label}
            </option>
          ))}
        </optgroup>
      ))}
    </VWSelect>
  );
}
